import { render, staticRenderFns } from "./RobotReplic.vue?vue&type=template&id=c5405d16&scoped=true"
import script from "./RobotReplic.vue?vue&type=script&lang=js"
export * from "./RobotReplic.vue?vue&type=script&lang=js"
import style0 from "./RobotReplic.vue?vue&type=style&index=0&id=c5405d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5405d16",
  null
  
)

export default component.exports